const IndustryList = [
  {
    companyName: "Thomson Reuters Europe",
    StartYear: "Jul 2024",
    EndYear: "Present",
    description: "As a Software Engineer at Pagero, which was acquired by Thomson Reuters, I contribute to the development of scalable, high-performance solutions that streamline document management for organizations. My team, Team Roadrunner, specializes in simplifying the integration of historical documents and real-time POS transactions from external systems. Our mission is to help businesses stay efficient, compliant, and connected by optimizing document flow across platforms.",
    positions: [
      {
        title: "Software Engineer II",
        StartYear: "Jan 2026",
        EndYear: "Present"
      },
      {
        title: "Software Engineer I",
        StartYear: "Jul 2024",
        EndYear: "Dec 2025"
      }
    ],
    details: [
        "Backend Development: Designing and developing robust services using Scala with ZIO to manage complex business logic, ensuring high availability and scalability",
        "Frontend Development: Building intuitive and responsive user and admin interfaces using React and TypeScript, focusing on delivering a seamless user experience",
        "Database Management: Optimizing PostgreSQL databases for efficient data flow, storage, and retrieval, ensuring high performance under load",
        "Service Architecture: Collaborating with the team to design and implement new services, including API design, service development, and integration with internal systems for seamless communication across platforms",
        "Performance Optimization: Continuously improving backend system performance by applying efficient coding practices and identifying areas for optimization",
        "Code Quality & Reviews: Leading code reviews and maintaining high standards for code quality and maintainability, ensuring industry best practices are followed",
        "Cross-Functional Collaboration: Collaborating closely with other teams to integrate systems, troubleshoot issues, and ensure smooth end-to-end service delivery",
        "Tech Stack : Scala, ZIO, React, TypeScript, PostgreSQL"
    ],
    Logo: require("../asset/pagero_logo.jpeg")
  },
  {
    companyName: "WSO2",
    Position: "Computer Engineering Intern - Ballerina Team",
    StartYear: "Feb 2023",
    EndYear: "Aug 2023",
    details: [
        "Research project about integration mediator framework", 
        "Developed Integration project evaluation platform",
        "Tech Stack : Ballerina, React, TypeScript, Docker, GitHub, MySQL, WSO2 Asgardeo, WSO2 Choreo"
    ],
    Logo: "https://wso2.cachefly.net/wso2/sites/images/brand/downloads/wso2-inverted-logo.png"
  }
];
const IndustryData = {IndustryList};
export default IndustryData;
